import React from 'react';
import { injectIntl } from 'react-intl';
import Modal from 'components/Modal';

import PageNewForm from 'components/forms/cms/PageNewForm';

class PageNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      className: '',
    };
  }

  setClassName = className => {
    this.setState({ className });
  };

  close = () => {
    this.setState({ className: '' }, () => {
      const { close } = this.props;
      close();
    });
  };

  render() {
    const {
      intl: { messages },
      show,
      onSubmitParent,
    } = this.props;
    const { className } = this.state;

    return (
      <Modal show={show} onHide={this.close} bsSize="lg" className={className}>
        <Modal.Header closeButton>
          <Modal.Title>{messages.create_page}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PageNewForm onSubmitParent={onSubmitParent} setModalClassName={this.setClassName} />
        </Modal.Body>
      </Modal>
    );
  }
}

export default injectIntl(PageNew);
